import React, { useState } from 'react';

const Input = ({
  type = 'text',
  label,
  placeholder,
  icon,
  className = '',
  value,
  onChange,
  required = false,
  ...props
}) => {
  const [inputType, setInputType] = useState(type);

  const togglePasswordVisibility = () => {
    setInputType(inputType === 'password' ? 'text' : 'password');
  };

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-gray-700 text-sm font-medium mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <i className={`${icon} text-gray-400`}></i>
          </div>
        )}
        <input
          type={inputType}
          className={`form-input w-full ${
            icon ? 'pl-10' : 'pl-4'
          } pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-200 ${className}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          {...props}
        />
        {type === 'password' && (
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={togglePasswordVisibility}
          >
            <i className={`fas ${inputType === 'password' ? 'fa-eye' : 'fa-eye-slash'} text-gray-400 hover:text-gray-600`}></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default Input;